import { ColumnViewModel } from '../../shared/column-types';

export const CHEMICALS_VDA_SUMMARY: ColumnViewModel = {
  columns: [
    'evidenceTimeline',
    'chemPrefName',
    'chemID',
    'geneSymbol',
    'variantStrID',
    'diseaseName',
    'diseaseUMLSCUI',
    'geneNcbiIDs',
    'numDiseasesAssociatedToVariant',
    'score',
    'sourceScore',
    'mostSevereConsequences',
    'numberChemsIncludedInEvidence',
    'numPMIDsupportingAssociation',
    'yearInitial',
    'yearFinal',
    'EI',
    'variantDSI',
    'variantDPI',
    'chromosome',
    'hgvsc',
    'hgvsp',
    'coord',
    'alleles',
    'alleleFreqExome',
    'alleleFreqGenome',
    'DBSNPclass',
    'polyphen_score',
    'sift_score',
    'diseaseType',
    'diseaseClassName_MSH',
    'diseaseClassName_UMLS',
    'diseaseClassName_DO',
    'diseaseClassName_HPO',
    'prevalence',
    'disease_inheritance',
  ],
  defaultVisible: [
    'evidenceTimeline',
    'variantStrID',
    'diseaseName',
    'geneSymbol',
    'numDiseasesAssociatedToVariant',
    'score',
    'sourceScore',
    'mostSevereConsequences',
    'numPMIDsupportingAssociation',
    'yearInitial',
    'yearFinal',
    'EI',
    'variantDSI',
    'variantDPI',
    'chromosome',
  ],
};
